import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import axios from "axios";
import { mirage } from "ldrs";
import gsap from "gsap";
import localforage from "localforage";
import { FaFilePdf } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { FaRedo } from "react-icons/fa";
import { FaRegFilePdf } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
var repeatcount = 0;
var redoFile;
let intervalId;
const Exame = () => {
  mirage.register();
  const input_pass = useRef(null);
  const loader = useRef(null);
  const messageText = useRef(null);
  const message = useRef(null);
  const messageSpanSvg = useRef(null);
  const drop = useRef(null);
  const main = useRef(null);
  const labelsubmit = useRef(null);
  const more_actions = useRef(null);

  const down = useRef(null);
  const time = useRef(null);
  const count_down = useRef(null);
  const [saved, setsaved] = useState(false);
  const [pass, setPass] = useState("");
  const [prompt, setprompt] = useState(``);
  const [subprompt, setsubprompt] = useState(``);
  const [file_name, setfile_name] = useState("Add a file");
  const [question, setquestion] = useState([]);
  const [container, setcontainer] = useState([]);
  const [explain, setexplain] = useState(false);
 

  const handleFileChange = async (event) => {
    try {
      const file = event.target.files[0];

      // Validate file type
      if (!file.type.includes("application/pdf")) {
        setfile_name("Only PDF files are allowed.");
        return; // Prevent further processing if not a PDF
      }
      setfile_name(file.name);
      // Update state with the selected file
      redoFile = file;
      console.log(redoFile);
      // Handle re-upload case (assuming you have an `upload_file` function)
      if (event.target.id === "reupload") {
        await upload_file(); // Use async/await for clarity and error handling
      }
    } catch (error) {
      console.error("Error handling file change:", error);
      setfile_name("Add a file");
    }
  };
  async function upload_file() {
    if (redoFile) {
      setexplain(false);
      clearInterval(intervalId);
      var tl = gsap.timeline({});
      var tl2 = gsap.timeline({});
        tl2.to(count_down.current, {
          top: "-7%",
          ease: "elastic.out(1,0.5)",
          duration: 1.2,
          delay: 1,
        });
      tl.to(labelsubmit.current, {
        pointerEvents: "none",
        opacity: 0,
        duration: 0,
      }).to(labelsubmit.current, { display: "none", duration: 0 });
      showloader();
      try {
        setquestion([]);

        const data = new FormData();
        data.append("file", redoFile);
        const response = await axios.post(
          "https://joodyy.netlify.app/.netlify/functions/app/create_exame",
          // "http://localhost:5001/create_exame",
          data
        );
        hideloader();
        if (response.data.state == true) {
          show_timer();
          setcontainer(response.data.res);
          more_actions.current.dataset.click = "false";
          down.current.dataset.click = "false";
        } else if (repeatcount < 3) {
          upload_file();
          repeatcount++;
          console.log(repeatcount);
        } else if (response.data.state == false) {
          setsaved(null);
          await showMessage(response.data.message);
        }
      } catch (error) {
        if (repeatcount < 3) {
          upload_file();
          repeatcount++;
          console.log(repeatcount);
        } else {
          hideloader();
          setsaved(null);
          await showMessage("process failed");
        }
      }
    } else {
      hideloader();
      setsaved(null);
      await showMessage("chose a file");
    }
  }
  useEffect(() => {
    check();
  }, []);
  async function check() {
    const pass = await localforage.getItem("passcode");
    if (!pass) {
      show();
    }
  }
  async function showMessage(text) {
    const tl = gsap.timeline({});
    message.current.style = "";
    await tl
      .fromTo(
        message.current,
        {
          top: "-2rem",
        },
        {
          top: "1rem",
          ease: "elastic.out(1,0.5)",
          duration: 1.5,
          overwrite: true,
        }
      )
      .fromTo(
        message.current,
        {
          minWidth: "0px",
        },
        {
          minWidth: "180px",
          ease: "elastic.out(1,0.75)",
          duration: 1,
        }
      )
      .fromTo(
        messageText.current,
        {
          opacity: 0,
          flexGrow: 0,
          textContent: "",
          height: "0",
        },
        {
          textContent: text,
          flexGrow: 1,
          height: "fit-content",
          opacity: 1,
        }
      )
      .fromTo(
        messageSpanSvg.current,
        {
          opacity: 0,
        },
        {
          opacity: 1,
        }
      )
      .to(messageText.current, {
        opacity: 0,
        delay: 2,
      })
      .to(messageText.current, {
        flexGrow: 0,
        height: "0",
      })
      .to(messageSpanSvg.current, {
        opacity: 0,
        delay: -1,
      })
      .to(messageText.current, {
        textContent: "",
      })
      .to(message.current, {
        minWidth: "0px",
      })
      .to(message.current, {
        top: "-3rem",
      });
  }
  const memoSaved = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="m438-400 198-198-57-56-141 141-57-57-57 57 114 113ZM200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Z" />
    </svg>
  );
  const memoRemoved = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M840-680H600v-80h240v80ZM200-120v-640q0-33 23.5-56.5T280-840h240v80H280v518l200-86 200 86v-278h80v400L480-240 200-120Zm80-640h240-240Z" />
    </svg>
  );
  const error = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>
  );
  const done = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
    </svg>
  );
  async function addpasscode() {
    showloader();
    try {
      const data = {
        pass: pass,
      };
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/create/pass",
        data
      );

      hideloader();
      if (response.data.state == true) {
        hide();
        await localforage.setItem("passcode", pass);
      } else {
        setsaved(null);
        await showMessage(response.data.message);
      }
    } catch (error) {
      setsaved(null);
      hideloader();
      await showMessage("server error");
    }
  }
  function hide() {
    gsap.to(input_pass.current, {
      y: 100,
      opacity: 0,
      pointerEvents: "none",
      duration: 0.7,
      ease: "expo.out",
    });
  }
  function show() {
    var tl = gsap.timeline();
    tl.fromTo(
      input_pass.current,
      { y: 100, opacity: 0, pointerEvents: "none" },
      {
        y: 0,
        opacity: 1,
        pointerEvents: "all",
        duration: 0.7,
        ease: "expo.out",
      }
    );
  }
  function showloader() {
    gsap.to(loader.current, { opacity: 1 });
  }
  function hideloader() {
    gsap.to(loader.current, { opacity: 0 });
  }
  function calc() {
    var tl = gsap.timeline();
    tl.to(count_down.current, {
      top: "-7%",
      ease: "elastic.out(1,0.5)",
      duration: 1.2,
      delay: 2,
    });
    setexplain(true);
    fadeOut();
    var answered = 0,
      total = 0;
    document.querySelectorAll(".vh1").forEach((el, index) => {
      if (el.checked) {
        answered++;
      }
      total = index;
    });
    var result = ((answered / total) * 100).toFixed(2);
    gsap.to(labelsubmit.current, { pointerEvents: "none", opacity: 0 });
    gsap.to(labelsubmit.current, { display: "none" });
    if (result <= 50) {
      setprompt(`${result}%`);
      setsubprompt(`better luck next time :/`);
    } else if (result <= 70) {
      setprompt(`${result}%`);
      setsubprompt(`you are doing great :)`);
    } else if (result <= 85) {
      setprompt(`${result}%`);
      setsubprompt(`🔥 thats a wonderfull score keep it up 🔥`);
    } else if (result <= 100) {
      setprompt(`${result}%`);
      setsubprompt(`🔥🔥 maashhhhallllahhh 🔥🔥`);
    }
    fadeIn2();
  }
  function fadeIn() {
    document.querySelectorAll(".question").forEach((el, index) => {
      el.style = "pointer-events: none;";
    });
    gsap.fromTo(
      ".alert",
      { opacity: 0, y: 20 },
      {
        y: 0,
        opacity: 1,
        pointerEvents: "all",
        duration: 0.3,
      }
    );
  }
  function fadeOut() {
    document.querySelectorAll(".question").forEach((el, index) => {
      el.style = "pointer-events: all;";
    });
    gsap.fromTo(
      ".alert",
      { opacity: 1, y: 0 },
      {
        y: -20,
        opacity: 0,
        pointerEvents: "none",
        duration: 0.3,
      }
    );
  }
  function fadeIn2() {
    document.querySelectorAll("label:has(.vh1)").forEach((ele) => {
      ele.classList.add("green");
    });
    gsap.fromTo(
      ".alert2",
      { opacity: 0, y: 20 },
      {
        y: 0,
        opacity: 1,
        pointerEvents: "all",
        duration: 0.3,
      }
    );
  }
  function fadeOut2() {
    gsap.fromTo(
      ".alert2",
      { opacity: 1, y: 0 },
      {
        y: -20,
        opacity: 0,
        pointerEvents: "none",
        duration: 0.3,
      }
    );
  }
  function view() {
    if (more_actions.current.dataset.click == "false") {
      more_actions.current.dataset.click = "true";
      down.current.dataset.click = "true";
    }
  }
  const savememo = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-false-clr)"
    >
      <path d="M200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Z" />
    </svg>
  );
  const share = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-false-clr)"
    >
      <path d="M240-40q-33 0-56.5-23.5T160-120v-440q0-33 23.5-56.5T240-640h80q17 0 28.5 11.5T360-600q0 17-11.5 28.5T320-560h-80v440h480v-440h-80q-17 0-28.5-11.5T600-600q0-17 11.5-28.5T640-640h80q33 0 56.5 23.5T800-560v440q0 33-23.5 56.5T720-40H240Zm200-727-36 36q-12 12-28 11.5T348-732q-11-12-11.5-28t11.5-28l104-104q12-12 28-12t28 12l104 104q11 11 11 27.5T612-732q-12 12-28.5 12T555-732l-35-35v407q0 17-11.5 28.5T480-320q-17 0-28.5-11.5T440-360v-407Z" />
    </svg>
  );
  function show_timer() {
    var tl = gsap.timeline({});
    tl.to(".timer", { bottom: "0%" });
  }
  async function start_timer() {
    var tl = gsap.timeline({});

    await tl
      .to(".timer", { bottom: "-100%" })
      .to(main.current, { opacity: 1 })
      .to(main.current, { pointerEvents: "all" })
      .to(labelsubmit.current, { display: "flex" })
      .to(labelsubmit.current, { pointerEvents: "all", opacity: 1 });
    setquestion(container);

    await tl.to(count_down.current, {
      top: "1%",
      ease: "elastic.out(1,0.5)",
      duration: 1.2,
    });
    countdownTimer(300);
  }
  function countdownTimer(seconds) {
    
    let remainingSeconds = seconds;

    const countdownElement = time.current;
    async function updateCountdown() {
    // if (stop) {
      //   clearInterval(intervalId);
      //  
      //   setstop(false);
      // }
      const minutes = Math.floor(remainingSeconds / 60);
      const seconds = remainingSeconds % 60;

      const formattedTime = `${minutes}:${seconds.toString().padStart(2, "0")}`;
      countdownElement.textContent = formattedTime;

      if (remainingSeconds <= 0) {
        clearInterval(intervalId);
        countdownElement.textContent = "Time is up!";
        await gsap.to(time.current, { color: "var(--bg-clr)" });
        calc();
      } else if (remainingSeconds <= 30) {
        gsap.to(time.current, { color: "red" });
      }
      remainingSeconds--;
    }
    intervalId = setInterval(updateCountdown, 1000);
  }

  return (
    <article
      onDoubleClick={() => {
        if (more_actions.current.dataset.click == "true") {
          more_actions.current.dataset.click = "false";
          down.current.dataset.click = "false";
        }
      }}
    >
      <div className="count_down" ref={count_down}>
        <p ref={time}>0:00</p>
      </div>
      <div className="timer">
        <div className="text">
          <h1>timer</h1>
          <p>you have 5 minute to complete the exame</p>
        </div>
        <div className="terms">
          <ul>
            <li>
              if you leave the page the exame will be canceled immediatley.
            </li>
            <li>
              the exame contains a combination of T&F questions and multiple
              choices questions.
            </li>
            <li>
              after submitting your answers, the program will provide you with
              your totla score.
            </li>
            <li>
              at the end of the exame you will get an explanation or a
              difinition of the right answer.
            </li>
          </ul>
        </div>
        <div className="start">
          <div onClick={start_timer}>
            <p>start</p>
          </div>
        </div>
      </div>
      <div className="message" ref={message}>
        <p ref={messageText}></p>
        <span ref={messageSpanSvg}>
          {saved === false && memoRemoved}
          {saved === true && memoSaved}
          {saved === null && error}
          {saved === "done" && done}
        </span>
      </div>
      <div className="alert">
        <h3>Are you sure you want to submit your answers ?</h3>
        <div className="btns">
          <button onClick={fadeOut}>
            <p>no</p>
          </button>
          <button onClick={calc}>
            <p>yes</p>
          </button>
        </div>
      </div>
      <div className="alert2">
        <h3>{prompt}</h3>
        <p>{subprompt}</p>
        <div className="btns">
          <button onClick={fadeOut2}>
            <p>done</p>
          </button>
        </div>
      </div>
      <form
        className="input_pass"
        ref={input_pass}
        onSubmit={(e) => {
          e.preventDefault();
          addpasscode();
        }}
      >
        <label htmlFor="pass">
          <p>enter passcode</p>
          <input
            type="text"
            id="pass"
            name="pass"
            onInput={(e) => {
              setPass(e.target.value);
            }}
          />
        </label>
        <span>
          <p>enter passcode to continue</p>
        </span>
      </form>
      <div className="hero">
        <h1 id="color">exame</h1>
        <h1 id="normal">make your own exame</h1>
      </div>
      <section>
        <main ref={main}>
          {question.length > 0
            ? question.map((item, index) => {
                if (item.TF) {
                  return item.TF.map((ele, subIndex) => (
                    <div className="question" key={`${subIndex}`}>
                      <h3>
                        {`${index + 1}-${subIndex + 1}`}) {ele.question}
                      </h3>
                      <label
                        className="radio"
                        htmlFor={`TRUE${index + 1}-${subIndex + 1}`}
                      >
                        <input
                          type="radio"
                          name={`q${index}-${subIndex}`}
                          // Changed name format
                          id={`TRUE${index + 1}-${subIndex + 1}`}
                          value={"true"}
                          className={
                            ele.answer.toString().toLowerCase() == "true"
                              ? "vh1"
                              : ""
                          }
                        />
                        <p>true</p>
                      </label>
                      <label
                        className="radio"
                        htmlFor={`FALSE${index + 1}-${subIndex + 1}`}
                      >
                        <input
                          type="radio"
                          name={`q${index}-${subIndex}`}
                          // Changed name format
                          id={`FALSE${index + 1}-${subIndex + 1}`}
                          value={"false"}
                          className={
                            ele.answer.toString().toLowerCase() == "false"
                              ? "vh1"
                              : ""
                          }
                        />
                        <p>false</p>
                      </label>
                      {explain == true ? (
                        <div className="explain">
                          <h4>
                            <p>view</p> <IoIosArrowDown />{" "}
                          </h4>
                          <div className="explanation">
                            <div>{ele.explain}</div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ));
                } else {
                  return item.M.map((ele, subIndex) => (
                    <div className="question" key={`${subIndex}`}>
                      <h3>
                        {`${index + 1}-${subIndex + 1}`}) {ele.question}
                      </h3>
                      <label
                        className="radio"
                        htmlFor={`A${index + 1}-${subIndex + 1}`}
                      >
                        <input
                          type="radio"
                          name={`q${index}-${subIndex}`}
                          // Changed name format
                          id={`A${index + 1}-${subIndex + 1}`}
                          value={"A"}
                          className={ele.answer == "A" ? "vh1" : ""}
                        />
                        <p>A) {ele.A}</p>
                      </label>
                      <label
                        className="radio"
                        htmlFor={`B${index + 1}-${subIndex + 1}`}
                      >
                        <input
                          type="radio"
                          name={`q${index}-${subIndex}`}
                          // Changed name format
                          id={`B${index + 1}-${subIndex + 1}`}
                          value={"B"}
                          className={ele.answer == "B" ? "vh1" : ""}
                        />
                        <p>B) {ele.B}</p>
                      </label>
                      <label
                        className="radio"
                        htmlFor={`C${index + 1}-${subIndex + 1}`}
                      >
                        <input
                          type="radio"
                          name={`q${index}-${subIndex}`}
                          // Changed name format
                          id={`C${index + 1}-${subIndex + 1}`}
                          value={"C"}
                          className={ele.answer == "C" ? "vh1" : ""}
                        />
                        <p>C) {ele.C}</p>
                      </label>
                      <label
                        className="radio"
                        htmlFor={`D${index + 1}-${subIndex + 1}`}
                      >
                        <input
                          type="radio"
                          name={`q${index}-${subIndex}`}
                          // Changed name format
                          id={`D${index + 1}-${subIndex + 1}`}
                          value={"D"}
                          className={ele.answer == "D" ? "vh1" : ""}
                        />
                        <p>D) {ele.D}</p>
                      </label>
                      {explain == true ? (
                        <div className="explain">
                          <h4>
                            <p>view</p> <IoIosArrowDown />{" "}
                          </h4>
                          <div className="explanation">
                            <div>{ele.explain}</div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ));
                }
              })
            : ""}
          <label htmlFor="submit" ref={labelsubmit}>
            <button id="submit" onClick={fadeIn}>
              <p>submit</p>
            </button>
          </label>
        </main>
      </section>
      <div
        className="more_actions"
        ref={more_actions}
        onClick={view}
        data-click="false"
      >
        <div className="down" ref={down}>
          <label htmlFor="reupload">
            <p>
              <FaPlus /> {file_name}
            </p>
            <input
              id="reupload"
              type="file"
              accept="application/pdf"
              name="file"
              onChange={handleFileChange}
            />
          </label>
          <div className="actions">
            <span
              onClick={() => {
                upload_file();
              }}
            >
              <FaRedo />
            </span>
            <span>{share}</span>
            <span
              onClick={() => {
                window.print();
              }}
            >
              <FaRegFilePdf />
            </span>
            <span>{savememo}</span>
          </div>
        </div>
      </div>
      <div className="loader" ref={loader}>
        <l-mirage size="60" speed="2.5" color="black"></l-mirage>
      </div>
    </article>
  );
};
export default Exame;
